<template>
  <div>
    <div class="subheader py-3 py-lg-3 subheader-transparent transparent">
      <div
        class="
          d-flex
          align-items-center
          justify-content-between
          flex-wrap flex-sm-nowrap
          container-fluid
          p-0
        "
      >
        <div class="d-flex align-items-baseline mr-5 mb-5">
          <h3 class="subheader-title text-dark font-weight-bold my-2 mr-3">
            Laporan Harian
          </h3>
        </div>
        <div class="d-flex align-items-center">
          <a
            :href="linkDownloadHarian()"
            target="_blank"
            class="btn btn-sm btn-danger font-weight-bold"
          >
            Download semua data
          </a>
        </div>
      </div>
    </div>
    <TableReport />
  </div>
</template>

<script>
import TableReport from '@/view/pages/report/TableReport'

export default {
  name: 'report',
  components: {
    TableReport,
  },
  methods: {
    linkDownloadHarian() {
      const url = process.env.VUE_APP_SERVICE_URL
      return `${url}administrator/cluster_immunization/export_all_data`
    },
  },
}
</script>
